import {
  estimatePaymentTermItemFromJSON,
  EstimatePaymentTermItemRecord,
  IEstimatePaymentTermItemData,
} from "common/records/PaymentTermItem";
import { List, Record } from "immutable";

export const paymentTermBreakdownFromJSON = (json: Partial<IPaymentTermBreakdown>): PaymentTermBreakdownRecord => {
  const record: IPaymentTermBreakdownRecord = { ...(json as any) };

  if (record.items) {
    record.items = List(record.items.map((pti) => estimatePaymentTermItemFromJSON(pti, false)));
  }

  return new PaymentTermBreakdownRecord(record);
};

export interface IPaymentTermBreakdown {
  items: IEstimatePaymentTermItemData[];
  kind: string;
}

export interface IPaymentTermBreakdownRecord {
  items: List<EstimatePaymentTermItemRecord>;
  kind: string;
}

const defaultPaymentTermBreakdownProps: IPaymentTermBreakdownRecord = {
  items: List<EstimatePaymentTermItemRecord>(),
  kind: "",
};

export class PaymentTermBreakdownRecord
  extends Record(defaultPaymentTermBreakdownProps)
  implements IPaymentTermBreakdownRecord {}
